'use strict';

angular.module('amexReconciliationApp')
  .service('SearchRepository', function SearchRepository($resource, $http, TransactionSearchModel) {
    var self = this;

    self.searchForIds = function (search) {
      var resource = $resource(TransactionSearchModel.url('advancedSearch'), {}, {
        search: {
          method: 'post',
          isArray: true
        }
      });

      return resource.search(TransactionSearchModel.queryParams(), search) //todo
        .$promise;
    };

    self.search = function (search) {
      var resource = $resource(TransactionSearchModel.url('advancedSearchBackendOnly'), {}, {
        search: {
          method: 'post',
          isArray: true
        }
      });

      return resource.search(TransactionSearchModel.queryParams(), search) //todo
        .$promise;
    };

    self.searchCount = function (search) {
      var resource = $resource(TransactionSearchModel.url('advancedSearchBackendOnlyCount'), {}, {
        count: {
          method: 'post',
          isArray: false
        }
      });

      return resource.count(TransactionSearchModel.queryParams(), search) //todo
        .$promise;
    };

  });


//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/repositories/SearchRepository.js
// module id = 620
// module chunks = 0